import type { Trace } from '@engine/models'
import type { AdminListResponse } from '@engine/models/admin'

import { ErrorState } from '#components/ErrorState'
import { KeyValueDisplay } from '#components/KeyValueDisplay'
import { LoadingState } from '#components/LoadingState'
import { TraceRow } from '#components/TraceRow'
import { useFetch } from '#hooks/useAdminResource.js'

interface TraceDetailsProps {
  trace: Trace
}

export const TraceDetails = ({ trace }: TraceDetailsProps) => {
  // The list omits request/response bodies, so the selected trace is refetched in full
  const { data, isLoading, error, refetch } = useFetch<
    AdminListResponse<Trace>
  >('traces', { traceId: trace.traceId, limit: 1 })

  const transactions = data?.items?.[0]?.transactions ?? []

  return (
    <div className="space-y-6">
      <KeyValueDisplay
        items={[
          { label: 'Trace ID', value: trace.traceId },
          { label: 'Layer', value: trace.category },
          { label: 'Action', value: trace.action },
          { label: 'Carrier', value: trace.carrier?.code },
          { label: 'Target ID', value: trace.targetId },
          { label: 'Client ID', value: trace.clientId },
        ]}
      />

      {isLoading ? (
        <LoadingState />
      ) : error ? (
        <ErrorState error={error.message} onRetry={() => refetch()} />
      ) : (
        <div className="space-y-2">
          {transactions.map((transaction, index) => (
            <TraceRow
              key={`${transaction.id}-${index}-${transaction.timeStamp}`}
              transaction={{ ...transaction, category: trace.category }}
            />
          ))}
        </div>
      )}
    </div>
  )
}
